// Portado de /tmp/astro/src/pages/videos.astro (site Astro). Hub do canal
// organizado pelos 7 pilares do Método SP.
import { REDES } from "@/lib/itv/site";
import { VIDEOS, type Video } from "@/lib/itv/videos";

// A ordem dos pilares é a mesma da página do método.
const PILARES = [
  { nome: "Alimentação", texto: "Uma estratégia que você consiga manter, não uma dieta temporária." },
  { nome: "Exercício e músculo", texto: "Movimento como tratamento, com atenção especial à massa muscular." },
  { nome: "Sono", texto: "Não existe saúde plena quando o organismo não consegue se recuperar." },
  { nome: "Metabólico-hormonal", texto: "O que os exames mostram, e o que fazer com o que eles mostram." },
  { nome: "Suplementação", texto: "O que tem evidência e indicação, sem protocolo pronto." },
  { nome: "Saúde emocional", texto: "Corpo e mente não funcionam separadamente." },
  { nome: "Propósito", texto: "Queremos saúde para alguma coisa." },
];

function slug(nome: string) {
  return nome.toLowerCase().replace(/[^a-zà-ú]+/g, "-");
}

const SECOES = PILARES.map((p) => ({
  ...p,
  videos: VIDEOS.filter((v) => v.pilar === p.nome).sort((a, b) => b.views - a.views),
})).filter((s) => s.videos.length > 0);

export function Videos() {
  return (
    <div className="pag-videos">
      <section className="hero">
        <div className="container hero-inner">
          <nav className="trilha" aria-label="Você está em">
            <a href="/">Home</a> <span aria-hidden="true">›</span>
            <span>Conteúdos</span> <span aria-hidden="true">›</span> <span>Vídeos</span>
          </nav>
          <p className="hero-sobretitulo">CANAL</p>
          <h1>
            O Método SP,
            <br />
            <em>explicado em vídeo.</em>
          </h1>
          <p className="hero-chamada">
            Assista aos vídeos abaixo.
          </p>
          <a className="btn-video-secundario hero-btn" href={REDES.youtube}>
            Ver o canal no YouTube
          </a>
        </div>
      </section>

      <nav className="atalhos" aria-label="Ir para um pilar">
        <div className="container atalhos-inner">
          {SECOES.map((s) => (
            <a href={`#${slug(s.nome)}`} key={s.nome}>
              {s.nome} <span>{s.videos.length}</span>
            </a>
          ))}
        </div>
      </nav>

      {SECOES.map((s) => (
        <section className="pilar" id={slug(s.nome)} key={s.nome}>
          <div className="container">
            <div className="pilar-topo">
              <p className="sobretitulo">PILAR</p>
              <h2>{s.nome}</h2>
              <p className="pilar-texto">{s.texto}</p>
            </div>
            <ul className="videos">
              {s.videos.map((v: Video) => (
                <li className="video" key={v.youtubeId}>
                  <a
                    className="video-capa"
                    href={`https://www.youtube.com/watch?v=${v.youtubeId}`}
                   
                    aria-label={`Assistir "${v.titulo}" no YouTube`}
                  >
                    <img
                      src={`/img/videos/${v.youtubeId}.webp`}
                      alt={`Capa do vídeo: ${v.titulo}`}
                      width={370}
                      height={208}
                      loading="lazy"
                    />
                    <span className="video-play" aria-hidden="true">
                      <img src="/icones/youtube-assistir.svg" width={60} height={42} alt="" loading="lazy" />
                    </span>
                    {v.duracao && <span className="video-duracao">{v.duracao}</span>}
                  </a>
                  <h3>
                    <a href={`https://www.youtube.com/watch?v=${v.youtubeId}`}>
                      {v.titulo}
                    </a>
                  </h3>
                  <p className="video-meta">
                    <img src="/icones/olho.svg" width={14} height={14} alt="" loading="lazy" />
                    {v.viewsRotulo}
                  </p>
                  <a className="video-rota" href={v.tratamento}>
                    Ver o tratamento →
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ))}

      <section className="canal">
        <div className="container canal-inner">
          <p className="canal-eyebrow">TEM MUITO MAIS</p>
          <h2>São mais de 400 vídeos no canal</h2>
          <p className="canal-texto">
            Aqui está uma seleção por pilar. O acervo completo, com os vídeos novos toda semana,
            fica no YouTube.
          </p>
          <a className="btn-video-secundario canal-btn" href={REDES.youtube}>
            Inscrever-se no canal
          </a>
        </div>
      </section>
    </div>
  );
}
